import { pick } from '../utils';
import { ValidationError } from './validation/validation-error';
export const getPrunedCategories = (categories, allCategories) => {
    if (!allCategories.length) {
        // No configured integrations found, so no categories will be sent (should not happen unless there's a configuration error)
        throw new ValidationError('Invariant: No consent categories defined in Segment', []);
    }
    return pick(categories, allCategories);
};
//# sourceMappingURL=pruned-categories.js.map